import { createAction, props } from '@ngrx/store'
import { EmployeeBankingInformationAPIModel } from 'src/models/api.model'

const prefix = '[employee]'

export const FETCH_EMPLOYEE_BANKING_INFO = createAction(
  `${prefix} FETCH_EMPLOYEE_BANKING_INFO`,
  props<{ employeeId: string }>()
)

export const FETCH_EMPLOYEE_BANKING_INFO_SUCCESS = createAction(
  `${prefix} FETCH_EMPLOYEE_BANKING_INFO_SUCCESS`,
  props<{ bankingInfo: EmployeeBankingInformationAPIModel[] }>()
)

export const CLEAR_EMPLOYEE_BANKING_INFO = createAction(`${prefix} CLEAR_EMPLOYEE_BANKING_INFO`)
